import React, { useEffect } from "react";
import PageBanner from "../Components/PageBanner";
import Navbar from "../Components/Navbar";

const TextPage = ({ title, text }) => {
  useEffect(() => {
    const ScrollToTop = () => {
      window.scrollTo(0, 0);
    };
    ScrollToTop();
  }, [title]);

  return (
    <div>
      {/* <PageBanner title={title} /> */}
      <Navbar />

      <div className="canvas pt-5">
        <div className="mt-5">
          {text}
        </div>
      </div>
    </div>
  );
};

export default TextPage;
